import { Card, Col, Empty, Row, Statistic } from "antd";
import { useEffect, useState } from "react";

import request from "@/api";
import { MyTaskAction } from "./MyTaskAction";

export interface MyTaskFiscalStat {
    key: string;
    label: string;
    count: number;
    permissions?: readonly string[];
}

interface MyTaskFiscalStatsProps {
    loadStats?: () => Promise<MyTaskFiscalStat[]>;
}

/** 复用 Vue 财税待办的两个统计接口。 */
export async function loadMyTaskFiscalStats(): Promise<MyTaskFiscalStat[]> {
    const [shipInfoServiceFee, oilFee] = await Promise.all([
        request.service.get("/admin/mytask/statisc/ship-info-service-fee"),
        request.service.get("/admin/mytask/statisc/oil-fee")
    ]);
    return [
        {
            key: "shipInfoServiceFee",
            label: "待确认船务信息服务费",
            count: Number(shipInfoServiceFee.data?.infoService || 0),
            permissions: ["ROLE_SHIP_ORDER_SERVICE_FEE_W"]
        },
        {
            key: "oilFee",
            label: "待确认油品费用",
            count: Number(oilFee.data?.toBeConfirmed || 0),
            permissions: ["ROLE_REFUELING_FEE_W"]
        }
    ];
}

/** 财税待办统计卡片，沿用 Vue 的待确认数量和状态文案。 */
export function MyTaskFiscalStats({ loadStats = loadMyTaskFiscalStats }: MyTaskFiscalStatsProps) {
    const [stats, setStats] = useState<MyTaskFiscalStat[]>([]);

    useEffect(() => {
        let disposed = false;
        void loadStats().then(result => {
            if (!disposed) setStats(result);
        });
        return () => {
            disposed = true;
        };
    }, [loadStats]);

    return (
        <Card title="财税">
            {stats.length ? (
                <Row gutter={[16, 16]}>
                    {stats.map(stat => (
                        <Col key={stat.key} xs={24} sm={12}>
                            <MyTaskAction stat={stat}>
                                <Statistic title={stat.label} value={stat.count} />
                            </MyTaskAction>
                        </Col>
                    ))}
                </Row>
            ) : (
                <Empty description="暂无数据" />
            )}
        </Card>
    );
}
